import { render, staticRenderFns } from "./RadioCurrency.vue?vue&type=template&id=fcf08c9a"
import script from "./RadioCurrency.vue?vue&type=script&lang=js"
export * from "./RadioCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports